import { useAuth } from "@Auth/useAuth";
import { MainMenu } from "@components/MainMenu/MainMenu";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTawkTo } from "@tawk/useTawkTo";
import { BillingBanner } from "@features/billing/components/BillingBanner";
import { DrawerHost } from "@common/SimpleDrawer/DrawerHost";

// Constants

// Styled components
const AppContainer = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      display: "flex",
      position: "relative",
      height: "100vh",
      overflow: "hidden",
    }}
  >
    {children}
  </Box>
);

const LoadingContainer = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
    Loading...
  </Box>
);

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { supabaseUser, isAuthenticated, baseUser } = useAuth();
  useTawkTo();

  // Send a freshly authenticated user landing on the root to the default page.
  // Only act on "/": re-navigating other paths here would strip their query
  // string (e.g. a deep-linked `?drawer=…`), which must survive a hard load.
  useEffect(() => {
    if (!supabaseUser || !isAuthenticated) return;
    if (location.pathname === "/") {
      navigate("/products/all-products", { replace: true });
    }
  }, [navigate, isAuthenticated, location.pathname, supabaseUser]);

  // Show loading state if either user or Statsig is not ready
  if (!baseUser) {
    return (
      <AppContainer>
        <LoadingContainer />
      </AppContainer>
    );
  }

  return (
    // <StatsigProvider client={client}>
    <AppContainer>
      <MainMenu />
      <Box
        sx={{
          height: "100vh",
          overflow: "auto",
          width: "100%",
          "@media (min-width: 769px)": {
            marginLeft: "47px",
            width: "calc(100% - 47px)",
          },
        }}
      >
        <BillingBanner />
        <Outlet />
      </Box>
      <DrawerHost />
    </AppContainer>
    // </StatsigProvider>
  );
};

export default App;
